<template>
  <v-dialog v-model="dialog" width="650" scrollable persistent>
    <v-card>
      <v-card-title>{{ release }} (Number of loci: {{ locinb }})</v-card-title>
      <v-card-text>
        {{ formatGenotypes }}
      </v-card-text>
      <v-card-actions>
        <v-btn class="primary" dark text @click="close()">
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    genotypes: {
      type: Array,
      default() {
        return [];
      },
    },
    locinb: {
      type: Number,
      default: 0,
    },
    release: {
      type: String,
      default: '',
    },
  },
  data() {
    return { dialog: true };
  },
  computed: {
    formatGenotypes() {
      return this.genotypes.map(g => g.id).join(', ');
    },
  },
  methods: {
    close() {
      this.$emit('close');
      this.dialog = false;
    },
  },
};
</script>
